var map = {
	"../app/dashboard/dashboard.module": [
		"./src/app/dashboard/dashboard.module.ts",
		"app-dashboard-dashboard-module"
	],
	"../app/investments/investments.module": [
		"./src/app/investments/investments.module.ts",
		"app-investments-investments-module"
	],
	"../app/loans/loans.module": [
		"./src/app/loans/loans.module.ts",
		"app-loans-loans-module"
	],
	"../app/profile/profile.module": [
		"./src/app/profile/profile.module.ts",
		"app-profile-profile-module"
	],
	"../app/savings/savings.module": [
		"./src/app/savings/savings.module.ts",
		"app-savings-savings-module"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;